import { Button } from "ui/components/button";
import { Label } from "ui/components/label";
import useTableFilters from "@/hooks/useTableFilters";
import UserCombobox from "components/directus/combobox/user";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";

export default function OpeningApplicantsFilters({
    filters,
    setFilters,
    setIsOpen,
    isOpen,
    clearFilters,
    defaultFilters,
}) {
    const {
        localFilters,
        applyFilters,
        clearLocalFilters,
        setLocalFilters,
    } = useTableFilters({
        filters,
        setFilters,
        setIsOpen,
        clearFilters,
        initialFilters: {
            employee: undefined,
            is_selected: undefined,
            ...defaultFilters,
        },
    });

    const selectedOptions = [
        { label: "All", value: "all" },
        { label: "Selected", value: "true" },
        { label: "Not Selected", value: "false" },
    ];

    return (
        <div className="w-full px-4 space-y-4">

            {/* employee */}
            <div>
                <Label className="mb-2 text-sm">Employee</Label>
                <UserCombobox
                    value={localFilters.employee?._eq}
                    onChange={(selectedItem) =>
                        setLocalFilters({
                            ...localFilters,
                            employee: selectedItem ? { _eq: selectedItem } : undefined,
                        })
                    }
                    dependenton={isOpen}
                />
            </div>

            
            {/* selected */}
            <div>
                <Label className="mb-2 text-sm">Selected</Label>
                <Select
                    onValueChange={(val) => {
                        let isSelected = undefined;
                        if (val === "true") isSelected = true;
                        if (val === "false") isSelected = false;

                        setLocalFilters({
                            ...localFilters,
                            is_selected: isSelected !== undefined ? { _eq: isSelected } : undefined,
                        });
                    }}
                    value={
                        localFilters?.is_selected?._eq === true 
                            ? "true" 
                            : localFilters?.is_selected?._eq === false 
                                ? "false" 
                                : "all"
                    }
                >
                    <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select" />
                    </SelectTrigger>
                    <SelectContent>
                        {selectedOptions.map((opt) => (
                            <SelectItem key={opt.value} value={opt.value}>
                                {opt.label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {/* Action Buttons */}
            <div className="flex place-self-end gap-4">
                <Button variant="outline" onClick={clearLocalFilters}>
                    Clear
                </Button>
                <Button onClick={() => applyFilters()}>Apply</Button>
            </div>
        </div>
    );
}
